import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/attributes/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import Grid from "@mui/material/Grid2"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import SingleSelect from "@/components/Select/SingleSelect"
import { Box, FormControl } from "@mui/material"
import { useCustomForm } from "@/hooks/useCustomForm"
import useAttributeKeys from "@/hooks/useAttributeKeys"
import CustomAutoComplete from "@/components/Select/CustomAutoComplete"
import { useState } from "react"

export default function AttributeList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Attributes</h5>
      </div>

      <CrudProvider>
        <AttributeTable />
      </CrudProvider>
    </>
  )
}

function AttributeTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Attributes"
        columns={columns}
        apiPath="attribute"
        // renderFilters={() => <AttributeFilter />}
      />

      {openDialog ? <Modal /> : null}
    </>
  )
}

const AttributeFilter = () => {
  const {
    api,
    register,
    handleSubmit,
    errors,
    isSubmitting,
    reset,
    setValue,
    control,
    Controller,
    getValues,
  } = useCustomForm({})

  const { attributeKeys, isLoading } = useAttributeKeys()
  const [selectedKey, setSelectedKey] = useState(null)

  return (
    <>
      <FormControl fullWidth>
        <CustomAutoComplete
          loading={isLoading}
          label="Attribute"
          options={attributeKeys}
          selectedValue={selectedKey}
          optionLabel="value"
          optionValue="id"
          onChange={(key) => {
            setSelectedKey(key)
          }}
          disabled={false}
        />
      </FormControl>
    </>
  )
}
